export const FETCH_ORGANISATION_FUNDS = 'fund/FETCH_ORGANISATION_FUNDS';
export const FETCH_ORGANISATION_EXPOSED_FUNDS =
  'fund/FETCH_ORGANISATION_EXPOSED_FUNDS';
export const FETCH_ORGANISATION_PENSION_SCHEMES =
  'fund/FETCH_ORGANISATION_PENSION_SCHEMES';
export const SEND_SUBMISSION_REQUEST = 'fund/SEND_SUBMISSION_REQUEST';
export const ADD_FUND = 'fund/ADD_FUND';
export const FETCH_STRATEGIES = 'fund/FETCH_STRATEGIES';
export const FETCH_PRODUCT_TYPES = 'fund/FETCH_PRODUCT_TYPES';
export const ADD_PORTFOLIO = 'fund/ADD_PORTFOLIO';
export const UPDATE_FUND = 'fund/UPDATE_FUND';
export const UPDATE_FUND_EXTRAS = 'fund/UPDATE_FUND_EXTRAS';
export const UPDATE_PORTFOLIO = 'fund/UPDATE_PORTFOLIO';
export const DELETE_FUND = 'fund/DELETE_FUND';
export const DELETE_PORTFOLIO = 'fund/DELETE_PORTFOLIO';
export const DOWNLOAD_COST_TEMPLATE = 'fund/DOWNLOAD_COST_TEMPLATE';
export const DOWNLOAD_ALL_COST_TEMPLATE = 'fund/DOWNLOAD_ALL_COST_TEMPLATE';
export const GET_BULK_DOWNLOAD_STATUS = 'fund/GET_BULK_DOWNLOAD_STATUS';
export const FETCH_ORGANISATION_SUB_FUNDS = 'fund/FETCH_ORGANISATION_SUB_FUNDS';
export const DELETE_SUBMISSION_REQUESTS = 'fund/DELETE_SUBMISSION_REQUESTS';
export const FETCH_ORGANISATION_MANAGERS = 'fund/FETCH_ORGANISATION_MANAGERS';
